import React, { useState } from 'react';
import { Spinner } from './Spinner'

export const LabelTituloGeneral = ({titulo}) => {
    return (
        <label className="text-[#336fbb] text-[25px] underline lg:text-[15px] lg:ml-[81%] lg:hidden">{titulo}</label>
    )
}